// Base component
_collow.components.Base = class {
  /**
   * @param {*} target html element
   * @param {*} types type of event
   * @param {*} handler trigger function
   * @param {*} options options for addEventListener
   * function to add eventlistener
   */
  listen(target, types, handler, options) {
    [types]
      .flat()
      .forEach((type_) => target.addEventListener(type_, handler, options));
    return handler;
  }

  /**
   * @param {*} target html element
   * @param {*} types type of event
   * @param {*} handler trigger function
   */
  unlisten(target, types, handler) {
    [types]
      .flat()
      .forEach((type_) => target.removeEventListener(type_, handler));
  }

  /**
   * @param {*} target html element
   * @param {*} types type of event
   * @param {*} detail extra information to pass
   * @param {*} bubbles bahavior,accepts boolean. default true.
   * dispatch a custom event.
   */
  dispatch(target, types, detail, bubbles = true) {
    [types]
      .flat()
      .forEach((type_) =>
        target.dispatchEvent(new CustomEvent(type_, { detail, bubbles }))
      );
  }

  /** add eventlistener to chagnes in form and unlisten to event active errorbox */
  errorboxActive = () => {
    this.listen(this.root, "change", this.errorboxInactive);
    this.unlisten(document, this.errorboxActive);
  };

  /** event on changes in form to hide errorbox */
  errorboxInactive = () => {
    this.dispatch(this.root, "_collow-input-change");
    this.unlisten(this.root, "change", this.errorboxInactive);
  };

  /**
   * @param {*} root html component
   * @param {*} params extra parameters for component
   * get the root, elements and parameters and instatiate the class
   * @returns the instantiated class.
   */
  static fromElement(root, params) {
    // Instantiate the component:
    const name = this.name.toKebabCase();
    const elements = this.getComponentElements(root, name);
    const params_ = {
      ...this.defaultParams,
      ...this.getComponentParams(root, name),
      ...params,
    };
    root._component = new this(root, elements, params_);

    // Clean up the component HTML:
    delete root.dataset.component;
    Object.entries(elements).forEach(
      ([key, element]) => delete element.dataset[`${name}:${key}`]
    );
    Object.keys(params_).forEach(
      (key) => delete root.dataset[`${name}:${key}`]
    );

    return root._component;
  }

  /**
   * @param {*} root
   * @param {*} name
   * @returns array of childeren elements
   */
  static getComponentElements(root, name) {
    const query = `.//*[@*[starts-with(name(), "data-${name}:")]]`;
    const result = new XPathEvaluator().evaluate(
      query,
      root,
      null,
      XPathResult.ORDERED_NODE_SNAPSHOT_TYPE
    );

    return Object.fromEntries(
      Array.from(result).map((element) => {
        const [key, value] = Object.entries(element.dataset).find(
          ([key, value]) => key.startsWith(`${name.toCamelCase()}:`)
        );
        return [key.split(":").pop(), element];
      })
    );
  }

  /**
   * @param {*} root
   * @param {*} name
   * @returns list of parameters
   */
  static getComponentParams(root, name) {
    return Object.fromEntries(
      Object.entries(root.dataset)
        .filter(([key, value]) => key.startsWith(`${name.toCamelCase()}:`))
        .map(([key, value]) => [
          key.split(":").pop(),
          this.parseExpression(value, root),
        ])
    );
  }

  /**
   * @param {*} expression
   * @param {*} element
   * @returns element that related to expression.
   */
  static parseExpression(expression, element) {
    if (!/^(\${1,2}|#|\^|&\$?|\*|@):/.test(expression)) {
      try {
        return JSON.parse(expression);
      } catch (error) {
        return expression;
      }
    }
    const [token, value_] = expression.split(":");
    switch (token) {
      case "$":
        return document.querySelector(value_);
      case "$$":
        return document.querySelectorAll(value_);
      case "#":
        return document.getElementById(value_);
      case "^":
        return element.closest(value_);
      case "&":
        return element.parentElement;
      case "&$":
        return element.parentElement.querySelector(value_);
      case "*":
        return JSON.parse(value_);
      case "@":
        return value_
          .replace(/\[(\d+)\]/, ".$1")
          .split(".")
          .reduce((obj, key) => obj && obj[key], window);
    }
  }
};
